export const DeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
    <path d="M25.0467 19.0829L15.9407 18.9986L14.1336 10.5985C13.8748 9.39482 15.1634 8.44597 16.2336 9.0523L31.9174 17.9302C32.8979 18.4849 32.8709 19.9079 31.8691 20.4331L15.9057 28.8047C14.8134 29.3769 13.5636 28.3933 13.8649 27.199L15.9375 18.997" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
